import React from 'react';
import Button from './ui/Button';

export default function SplitCtaSection({ audience = 'all', onCreator, onHire }) {
  const showCreator = audience === 'all' || audience === 'creator';
  const showProducer = audience === 'all' || audience === 'producer';
  const isSinglePanel = showCreator !== showProducer;

  return (
    <section className="mt-14 w-full">
      <div className={`grid grid-cols-1 ${showCreator && showProducer ? 'lg:grid-cols-2' : ''}`}>
        {/* Left - light */}
        {showCreator && (
          <div className="bg-[#F2F2F1] px-8 py-12 sm:px-12 sm:py-16">
            <div className={`${isSinglePanel ? 'mx-auto w-full max-w-6xl' : ''} text-left`}>
              <p className="text-xs font-semibold tracking-wider uppercase text-gray-400 mb-6">
                For Creators
              </p>
              <h2 className="text-5xl sm:text-6xl font-bold tracking-tight leading-[0.95] text-gray-900 max-w-md">
                Your talent deserves a stage.
              </h2>
              <p className="mt-5 text-sm sm:text-base text-gray-600 max-w-md">
                Join thousands learning, certifying, pitching, and getting hired on one platform built for the industry.
              </p>
              <Button type="button" variant="dark" onClick={onCreator} className="mt-8 px-8 py-3">
                Join as a creator →
              </Button>
            </div>
          </div>
        )}

        {/* Right - dark */}
        {showProducer && (
          <div className="bg-[#151618] px-8 py-12 sm:px-12 sm:py-16">
            <div className={`${isSinglePanel ? 'mx-auto w-full max-w-6xl' : ''} text-left`}>
              <p className="text-xs font-semibold tracking-wider uppercase text-gray-500 mb-6">
                For Producers
              </p>
              <h2 className="text-5xl sm:text-6xl font-bold tracking-tight leading-[0.95] text-white max-w-md">
                The talent you need is here.
              </h2>
              <p className="mt-5 text-sm sm:text-base text-gray-300 max-w-md">
                Access a pre-vetted, certified pool of production-ready professionals and project-ready creators.
              </p>
              <Button
                type="button"
                onClick={onHire}
                className="mt-8 px-8 py-3 bg-white text-gray-900 hover:bg-gray-100"
              >
                Start hiring →
              </Button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

